module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074e2_logo_200x200.4e9cd7d9.png";